import {ReloadButton} from '@flexinet/ui-components';
import {Box} from '@mantine/core';
import {useQueryClient} from '@tanstack/react-query';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({queryKey: ['payment-events']});
    };

    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
